import { render, staticRenderFns } from "./dragon-tiger.vue?vue&type=template&id=4b25e6a0&scoped=true&"
import script from "./dragon-tiger.vue?vue&type=script&lang=js&"
export * from "./dragon-tiger.vue?vue&type=script&lang=js&"
import style0 from "./dragon-tiger.styl?vue&type=style&index=0&id=4b25e6a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b25e6a0",
  null
  
)

export default component.exports